import { css } from 'linaria';
import { styled } from 'linaria/react';

export const adviceItemStyle = css`
  && {
    width: 372px;

    @media (--only-desktop) {
      width: 31.06%;
    }

    @media (--only-tablet) {
      width: 32.12%;
    }

    @media (--only-mobile) {
      width: 213px;
      margin-right: 10px;
    }

    &:last-of-type {
      margin-right: 0;
    }
  }
`;

export const AdviceImage = styled.img`
  display: block;
  width: 100%;
  height: auto;
  margin-bottom: 16px;
  border-radius: var(--rounding-l);

  @media (--to-desktop) {
    margin-bottom: 8px;
  }
`;

export const swiperStyle = css`
  && {
    width: 100%;

    && {
      @media (--only-tablet) {
        padding: 0;
        margin: 0;
      }
    }

    .swiper-wrapper {
      justify-content: space-between;
    }

    @media (--only-mobile) {
      justify-content: flex-start;
      width: auto;
      padding: 0 16px;
      margin: 0 -16px;
    }
  }
`;

export const subTitleStyle = css`
  @media (--to-desktop) {
    margin-bottom: 24px;
  }
`;
